import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';

import { TClipCategory } from '../types';

export async function getClipsCategories(): Promise<TClipCategory[]> {
  return mediaManagerClient.get('api/v1/clip_categories').then(({ data }) => data);
}

type QueryFnType = typeof getClipsCategories;

interface UseFeaturedPeopleParams {
  config?: QueryConfig<QueryFnType>;
}

export function useGetClipsCategories({ config }: UseFeaturedPeopleParams = {}) {
  return useQuery({
    ...config,
    queryKey: ['clips-categories'],
    queryFn: getClipsCategories,
  });
}
